module.exports = "/_next/static/media/3e30d5adb6341006f476d135147f497c.svg";